<div class="teaser mb-0">
  <div class="sidebar-content">
    <div class="d-flex flex-column">
      <span class="fw-bold lh-1 mb-3">{{ 'qualifications.singular' | translate | uppercase }}</span>
      <span class="main-qualification-text mb-2">{{
        inquiry?.mainQualification?.name +
          ' (' +
          ('externalEmployees.masterData.qualifications.primary' | translate) +
          ')'
      }}</span>
      <span
        *ngFor="let qualification of inquiry?.qualifications || []"
        class="alternative-qualification-text"
      >
        {{ qualification.name }}
      </span>
    </div>

    <ng-container *ngIf="inquiry?.requirements?.length">
      <hr />

      <div class="d-flex flex-column">
        <span class="fw-bold lh-1 mb-3">{{ 'work.conditions.alt' | translate | uppercase }}</span>
        <div
          class="row mb-2"
          *ngFor="let category of inquiry?.requirements || []"
        >
          <span class="lh-2">{{ category.name }}</span>
          <div
            class="d-flex align-items-center gap-2 text-justify"
            *ngFor="let requirement of category.requirements"
          >
            <i class="fa-solid fa-check me-1 text-dark"></i>
            <span class="lh-2">{{ requirement.name }}</span>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="inquiry?.inquiryDocument">
      <hr />
      <div class="d-flex flex-column">
        <span class="fw-bold lh-1 mb-2">{{ 'inquiry.inquiryDocument' | translate | uppercase }}</span>
        <base-inquiry-document-preview
          [documentInfo]="inquiry?.inquiryDocument"
          [canDeleteDocument]="false"
          [inquiryId]="inquiry?.id"
        ></base-inquiry-document-preview>
      </div>
    </ng-container>

    <hr />

    <div
      class="d-flex flex-column"
      [ngClass]="{ 'was-validated': submitted }"
    >
      <div class="d-flex align-items-start">
        <label
          [ngClass]="{ required: isEditNote }"
          class="fw-bold lh-1 mb-3"
        >
          {{ 'jobDescription' | translate | uppercase }}
        </label>
        <div class="d-flex ms-5">
          <div
            class="d-flex"
            *ngIf="inquiryId"
          >
            <i
              class="fa-solid pointer {{ isEditNote ? 'fa-check me-2' : 'fa-pen small' }}"
              [ngbTooltip]="isEditNote ? ('action.save' | translate) : ('action.edit' | translate)"
              (click)="editOrSaveJobDescription()"
            ></i>
            <i
              *ngIf="isEditNote"
              class="pointer fa-solid fa-xmark"
              [ngbTooltip]="'action.cancel' | translate"
              (click)="cancelJobDescriptionUpdate()"
            ></i>
          </div>
        </div>
      </div>
      <base-textarea
        *ngIf="isEditNote"
        #jobDescriptionInput
        placeholder="placeholders.jobDescription"
        class="col"
        [isRequired]="true"
        [formControl]="jobDescription"
        [isInvalid]="!!jobDescription.errors"
        [errorMessage]="jobDescription.errors | baseFieldValidation: { required: 'selectJobDescription' }"
        [autoGrowEnabled]="true"
      ></base-textarea>
      <span
        *ngIf="!isEditNote"
        class="mb-0 p-0 border-0"
      >
        {{ jobDescription.value }}
      </span>
    </div>

    <hr />

    <div class="d-flex flex-column">
      <span class="fw-bold lh-1 mb-2">{{ 'inquiry.remark' | translate | uppercase }}</span>
      <span class="text-justify">{{ inquiry?.remark | baseIsEmpty }}</span>
    </div>

    <hr />

    <div class="d-flex flex-column">
      <span class="fw-bold lh-1">{{ 'workEquipment' | translate | uppercase }}</span>
      <span class="fs-8 d-inline-block mb-2">{{ 'providedByUs' | translate }}</span>
      <span class="text-justify">{{ inquiry?.workEquipmentCustomer | baseIsEmpty }}</span>
    </div>

    <hr />

    <div class="d-flex flex-column">
      <span class="fw-bold lh-1">{{ 'workEquipment' | translate | uppercase }}</span>
      <span class="fs-8 d-inline-block mb-2">{{ 'providedByServiceProvider' | translate }}</span>
      <span class="text-justify">{{ inquiry?.workEquipmentPsp | baseIsEmpty }}</span>
    </div>

    <hr />

    <div class="d-flex flex-column">
      <span class="fw-bold lh-1 mb-2">{{ 'costUnit' | translate | uppercase }}</span>
      <span class="text-justify">{{ inquiry?.costUnit | baseIsEmpty }}</span>
    </div>

    <hr />

    <div class="d-flex flex-column align-items-start">
      <span class="fw-bold lh-1 mb-3">{{ 'inquiry.workConditions' | translate | uppercase }}</span>
      <span class="text-justify mb-2">
        {{ inquiry?.weeklyWorkingHours | baseIsEmpty }} {{ 'work.hoursPerWeek' | translate }}
      </span>
      <div
        class="d-flex align-items-center gap-2 mb-1"
        *ngFor="let shift of shiftTimes"
        [ngClass]="{
          'text-dark-gray': !existingShifts[shift.type]
        }"
        [ngbTooltip]="'shiftTimes.emptyShiftTooltip' | baseBusinessKey | translate"
        [disableTooltip]="existingShifts[shift.type]"
        tooltipClass="w-170px"
      >
        <i
          class="ms-2 fa-fw fa-regular {{ baseShiftIconsEnum[shift.type] }}"
          [title]="'shiftTimes.' + shift.type | baseBusinessKey | translate"
        ></i>
        <span>
          {{ 'externalEmployees.masterData.shiftReadiness.' + shift.type.toLowerCase() | baseBusinessKey | translate }}
          ({{ shift.startTime }} - {{ shift.endTime }})
        </span>
      </div>
      <div class="d-flex gap-1 ms-2 mt-3">
        <ng-container *ngFor="let weekday of weekdaysArray">
          <base-checkbox-weekdays
            [(ngModel)]="inquiryWeekdays[weekday]"
            [isDisabled]="true"
            [name]="'weekDays.' + weekday"
            [tooltip]="
              (inquiryWeekdays[weekday]
                ? ('tooltip.willingnessFor' | translate)
                : ('tooltip.noWillingnessFor' | translate)) + ('tooltip.weekDays.' + weekday | translate)
            "
          ></base-checkbox-weekdays>
        </ng-container>
      </div>
    </div>

    <hr />

    <div class="d-flex flex-column">
      <span class="fw-bold lh-1 mb-3">{{ 'operations.location' | translate | uppercase }}</span>
      <span class="text-dark-gray">{{ inquiry?.customer?.name }}</span>
      <span class="mb-1">{{ inquiry?.customerLocation?.name }}</span>
      <span class="fw-bold">{{ inquiry?.customerDepartment?.name }}</span>
      <span baseTruncate>{{ inquiry?.customerDepartment?.businessAddress?.street | baseIsEmpty }}</span>
      <span baseTruncate
        >{{ inquiry?.customerDepartment?.businessAddress?.postCode | baseIsEmpty }}
        {{ inquiry?.customerDepartment?.businessAddress?.city | baseIsEmpty }}</span
      >
    </div>

    <hr />

    <div class="d-flex flex-column">
      <span class="fw-bold lh-1 mb-3">{{ 'inquiry.contactPerson.serviceProvider' | translate | uppercase }}</span>
      <span>{{ inquiry?.responsible?.firstName }} {{ inquiry?.responsible?.lastName }}</span>
      <span class="fw-bold">{{ inquiry?.responsible?.email }}</span>
      <span>{{ inquiry?.responsible?.phone }}</span>
    </div>

    <hr />

    <div class="d-flex flex-column">
      <span class="fw-bold lh-1 mb-3">{{ 'billingAddress' | translate | uppercase }}</span>
      <span class="fw-bold">{{ inquiry?.customerDepartment?.billingContact?.legalName }}</span>
      <span>{{ inquiry?.customerDepartment?.billingContact?.billingAddress?.street }}</span>
      <span
        >{{ inquiry?.customerDepartment?.billingContact?.billingAddress?.postCode }}
        {{ inquiry?.customerDepartment?.billingContact?.billingAddress?.city }}</span
      >
      <span class="fw-bold">{{ inquiry?.customerDepartment?.billingContact?.email }}</span>
    </div>

    <hr />

    <div class="d-flex flex-column">
      <span class="fw-bold lh-1 mb-3">{{ 'inquiry.publishedBy' | translate | uppercase }}</span>
      <div class="d-flex gap-2">
        <base-avatar
          [size]="avatarSize.medium"
          [image]="inquiry?.publishedBy?.avatar || ''"
        ></base-avatar>
        <div class="d-flex flex-column">
          <span class="fw-bold">{{ inquiry?.publishedBy?.firstName + ' ' + inquiry?.publishedBy?.lastName }}</span>
          <p>{{ inquiry?.customer?.name }}</p>
          <span>{{ inquiry?.publishedAt | baseFormatDate: true }}</span>
        </div>
      </div>
    </div>

    <hr />

    <div class="d-flex flex-column">
      <span class="fw-bold lh-1 mb-3">{{ 'inquiry.createdBy' | translate | uppercase }}</span>
      <div class="d-flex gap-2">
        <base-avatar
          [size]="avatarSize.medium"
          [image]="inquiry?.createdBy?.avatar"
        ></base-avatar>
        <div class="d-flex flex-column">
          <span class="fw-bold">{{ inquiry?.createdBy?.firstName + ' ' + inquiry?.createdBy?.lastName }}</span>
          <p>{{ inquiry?.customer?.name }}</p>
          <span>{{ inquiry?.createdAt | baseFormatDate: true }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
